import { useMemo, useRef } from "react";
import useGetUrlParams from "../../../../../hooks/useGetUrlParams.js";
import { PRE_OPTED_ANCILLARIES_QUERY_PARAMS } from "../../../../../constants.js";
import useGlobalContext from "../../../../../hooks/useGlobalContext.js";
import { getSirfStatus } from "../../../../../store/selectors/sirf.js";
import { isOfGoogleFlightsOrigin } from "../../../../../utils/marketing-url-params.js";
export function useFlightDetailsFooterMobileController(props) {
    const { flight } = props;
    const { getUrlParam } = useGetUrlParams();
    const { features } = useGlobalContext();
    const footerContainerRef = useRef(null);
    const enableGfsPosMismatch = useMemo(() => {
        return features["FLIGHTS_META_ENABLE_GFS_FOR_POS_MISMATCH"] && isOfGoogleFlightsOrigin();
    }, [features]);
    const sirfStatus = useMemo(() => {
        return flight?.subsidizedFares ? getSirfStatus(flight?.subsidizedFares) : undefined;
    }, [flight]);
    const showSirfEligibilityMessage = !!sirfStatus;
    const isFlexTicket = useMemo(() => {
        return !!getUrlParam(PRE_OPTED_ANCILLARIES_QUERY_PARAMS.flexibleTicket);
    }, [getUrlParam]);
    return {
        sirfStatus,
        isFlexTicket,
        footerContainerRef,
        enableGfsPosMismatch,
        showSirfEligibilityMessage
    };
}
